module.exports = __webpack_public_path__ + "img/headPortrait.b5932c25.png";